import React, { useEffect, useState } from 'react';
import { api } from '../../App';
import toast from 'react-hot-toast';

function Row({ it }) {
  const [open, setOpen] = useState(false);
  const state = it.done === true ? 'done' : it.done === false ? 'todo' : 'manual';
  const icon = state === 'done' ? 'fa-circle-check text-emerald-500' : state === 'todo' ? 'fa-circle-xmark text-rose-500' : 'fa-circle-dot text-amber-500';
  return (
    <div className="border-b border-border last:border-0" data-testid={`golive-item-${it.key}`}>
      <button onClick={() => setOpen(o => !o)} className="w-full text-left px-4 py-3 flex items-center gap-3 hover:bg-surface-alt/60 transition-colors">
        <i className={`fa-solid ${icon} text-base`} />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-text-primary">{it.label}</p>
          <p className="text-[11px] text-text-muted truncate">{it.detail}</p>
        </div>
        <i className={`fa-solid fa-chevron-${open ? 'up' : 'down'} text-[10px] text-text-muted`} />
      </button>
      {open && (
        <div className="px-4 pb-4 pl-11 text-xs text-text-secondary leading-relaxed" data-testid={`golive-how-${it.key}`}>
          {it.how}
          {it.url && <a href={it.url} target="_blank" rel="noreferrer" className="ml-2 font-semibold text-primary hover:underline">Open <i className="fa-solid fa-arrow-up-right-from-square text-[9px]" /></a>}
        </div>
      )}
    </div>
  );
}

export default function GoLiveChecklist() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get('/api/system/go-live').then(r => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const wipeDemo = async () => {
    if (!window.confirm('Remove every demo-labelled lead and proposal?')) return;
    setBusy(true);
    try { const r = await api.delete('/api/demo'); toast.success(`Demo data removed (${r.data.leads_removed} leads, ${r.data.proposals_removed} proposals)`); }
    catch { toast.error('Wipe failed'); }
    setBusy(false);
  };

  if (!data) return <div className="card p-6 text-sm text-text-muted" data-testid="golive-loading">Checking go-live readiness…</div>;
  const blockers = data.items.filter(i => i.group === 'blocker');
  const rec = data.items.filter(i => i.group === 'recommended');
  return (
    <div className="card overflow-hidden" data-testid="golive-checklist">
      <div className="px-6 py-5 border-b border-border flex items-center justify-between gap-4 flex-wrap" style={{ background: '#0C2417' }}>
        <div>
          <p className="text-[10px] font-bold uppercase tracking-widest text-amber-300">Go-live readiness</p>
          <h3 className="font-heading text-xl font-bold text-white mt-1">{data.blockers_done} of {data.blockers_total} launch blockers cleared</h3>
          <p className="text-xs text-slate-300 mt-1">Everything above the line must be green before real homeowners and investors use the platform. Tap a row for where to get it.</p>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={load} className="px-3 py-2 rounded-xl text-xs font-semibold bg-white/10 text-white hover:bg-white/20" data-testid="golive-refresh-btn"><i className="fa-solid fa-rotate mr-1.5" />Re-check</button>
          <button onClick={wipeDemo} disabled={busy} className="px-3 py-2 rounded-xl text-xs font-semibold text-[#0C2417] disabled:opacity-60" style={{ background: '#FAAB1C' }} data-testid="golive-wipe-demo-btn"><i className="fa-solid fa-broom mr-1.5" />Wipe demo data</button>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-border">
        <div>
          <p className="px-4 pt-4 pb-2 text-[10px] font-bold uppercase tracking-widest text-rose-600">Launch blockers</p>
          {blockers.map(it => <Row key={it.key} it={it} />)}
        </div>
        <div>
          <p className="px-4 pt-4 pb-2 text-[10px] font-bold uppercase tracking-widest text-sky-600">Recommended before scale</p>
          {rec.map(it => <Row key={it.key} it={it} />)}
        </div>
      </div>
    </div>
  );
}
